
// ROUTES
require('modules/workshop-session/routes/workshop-session');

// CONTROLLERS
require('modules/workshop-session/controllers/workshop-session');
require('modules/workshop-session/controllers/list');
require('modules/workshop-session/controllers/create');
require('modules/workshop-session/controllers/edit');

// SERVICES
require('modules/workshop-session/services/workshop-session');
require('modules/workshop-session/services/list');
require('modules/workshop-session/services/create');
require('modules/workshop-session/services/edit');
require('modules/workshop-session/services/delete');


angular.module('unica_workshop_session', [

	// ROUTES
	'unica_workshop_session.workshop_session_routes',

	// CONTROLLERS
	'unica_workshop_session.workshop_session_controllers',

	// SERVICES
	'unica_workshop_session.workshop_session_services'

]);